import { HTTPService } from './HTTPService';
import { autoinject } from 'aurelia-dependency-injection';

const ACCESS_TOKEN_KEY = 'access_token';

export class TokenServiceConfig {
  apiBaseUrl: string;
  applicationId: string;
  defaultTenantSubdomain: string;
}

@autoinject
export class TokenService {
  constructor(private config: TokenServiceConfig, private httpService: HTTPService) { }

  private async getTenantSubdomain(): Promise<string> {
    return window.location.host.split('.')[0];
  }

  async requestSSOToken(): Promise<any> {
    const { apiBaseUrl, applicationId } = this.config;
    const callbackUrl = `${location.protocol}//${location.host}`;

    const tenantSubdomain = await this.getTenantSubdomain();

    try {
      return await this.httpService.request({
        url: `${apiBaseUrl}/api/applications/${applicationId}/token`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: {
          tenantSubdomain,
          callbackUrl,
        },
      });
    } catch (err) {
      if (err.status === 404) {
        err.displayMessage = `We're sorry, the page you requested was not found. Please check the address and try again.`;
        err.code = 'invalid-subdomain';
        throw err;
      }
    }
  }

  async exchangeToken({ tenantId, applicationId }: { tenantId: string, applicationId: string }): Promise<any> {
    const { apiBaseUrl } = this.config;
    const accessToken = this.getAccessToken();

    const response = await this.httpService.request({
      url: `${apiBaseUrl}/identity/tenants/${tenantId}/oauth/token`,
      method: 'POST',
      headers: { Authorization: `Bearer ${accessToken}` },
      body: { grant_type: 'token_exchange', audience: applicationId },
    });

    return response.access_token;
  }

  getAccessToken(): string | null {
    return sessionStorage.getItem(ACCESS_TOKEN_KEY);
  }

  setAccessToken(accessToken: string): void {
    return sessionStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
  }

  clearAccessToken(): void {
    return sessionStorage.removeItem(ACCESS_TOKEN_KEY);
  }
}



// WEBPACK FOOTER //
// ./src/support/TokenService.ts